module.exports = __webpack_public_path__ + "static/img/logo.c42f4e25.png";